import React, { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { getErrorFromResponse } from "../../../../../../../../../utility/utils";
import { ProduccionV2Api } from "../../../../../api/ProduccionV2Api";
import { ESTADOS_PALETIZACION } from "../../../../../../../../../utility/constants";

export const useDetallePaletizacion = (idPaletizacion, regresar) => {
    const {
        getDetallePaletizacion,

        cargando,
    } = ProduccionV2Api();

    const [pallets, setPallets] = useState([]);
    const [fueAtendidoPorBodega, setFueAtendidoPorBodega] = useState(false);
    const [metricasPaletizacion, setMetricasPaletizacion] = useState({});

    const GetDetallePaletizacion = async (idPaletizacion) => {
        try {
            const response =
                (await getDetallePaletizacion(idPaletizacion)) || {};
            setPallets(response.pallets || []);
            setFueAtendidoPorBodega(
                response.estado !== ESTADOS_PALETIZACION.PENDIENTE &&
                    response.estado !== ESTADOS_PALETIZACION.SIN_ENVIAR,
            );
            setMetricasPaletizacion(response.metricas || {});
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener los pallets de la paletización",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
            setPallets([]);
            setMetricasPaletizacion({});
        }
    };

    useEffect(() => {
        if (idPaletizacion) {
            GetDetallePaletizacion(idPaletizacion);
        }
    }, [idPaletizacion]);

    return {
        pallets,
        metricasPaletizacion,
        fueAtendidoPorBodega,

        cargando,
    };
};
